@if (error()) {
  <app-error [error]="error()" />
} @else if (!isInitialized()) {
  <!-- TODO In the future we could perhaps show a status message/error underneath the spinner per init step. -->
  <zenith-spinner zn-show />
} @else {
  <app-root-new />
}
